/**
 * Field formatters and display labels for the Bank Transactions
 * change-history feed. Covers both per-transaction edits and
 * canonical-account edits.
 *
 * Used by:
 *  - `TransactionDetailSheet.tsx` (transaction edits)
 *  - `BankTransactionsDocumentsPanel.tsx` (canonical account edits)
 */

const TRANSACTION_TYPE_LABELS: Record<string, string> = {
  employee: "Possible employee",
  trade_third_parties: "Trade & third parties",
  government_statutory: "Government & statutory",
  financial_institutions: "Financial institutions",
  utilities_rent: "Utilities & rent",
  internal_intercompany: "Internal / inter-company",
  professional_advisors: "Professional advisors",
  software_subscriptions: "Software & subscriptions",
  insurance: "Insurance",
  fuel: "Fuel",
  retail: "Retail",
  travel: "Travel",
  related_party: "Related party",
  unknown: "Unknown",
};

export const BANK_TRANSACTION_FIELD_FORMATTERS: Record<
  string,
  (value: unknown) => string
> = {
  // Transaction-level
  transactionType: (v) =>
    TRANSACTION_TYPE_LABELS[String(v)] ?? String(v ?? "\u2014"),
  counterpartyName: (v) => String(v ?? "\u2014"),
  notes: (v) => String(v ?? "\u2014"),
  // Canonical-account-level
  accountName: (v) => String(v ?? "\u2014"),
  cardholderName: (v) => String(v ?? "\u2014"),
  institution: (v) => String(v ?? "\u2014"),
  accountNumber: (v) => String(v ?? "\u2014"),
  bsb: (v) => String(v ?? "\u2014"),
};

export const BANK_TRANSACTION_FIELD_LABELS: Record<string, string> = {
  transactionType: "Transaction type",
  counterpartyName: "Counterparty",
  notes: "Notes",
  accountName: "Account name",
  cardholderName: "Cardholder",
  institution: "Institution",
  accountNumber: "Account number",
  bsb: "BSB",
};
